// eslint-disable-next-line import/prefer-default-export
export const APP_VERSION = `v.2024.3.0`
